// M8.2 Decision Inbox surface flag.
//
// Env var: VITE_DECISIONS_V2_ENABLED. Strict `=== 'true'`, default OFF.
// Unset, 'false', '1', 'yes', 'TRUE', etc. all stay OFF.
//
// Flag off: App.tsx does not register /v2/decisions/*. The catch-all
// is RootRedirect: an authenticated session goes to /home, an
// unauthenticated session goes to /landing. There is no dedicated
// 404 page. All existing routes work unchanged.
//
// Flag on: one splat renders the inbox and the detail child. Gate 2
// (Budget authorizations) stays read-only until #723 ships its write
// route. Workflow and unknown types stay read-only. Gate 1, Gate 3,
// Gate 4, and rights buttons render disabled until their POST
// handlers land.
//
// Per 2026-10-30 M7/M8 amendment §4.8.

export function isDecisionsV2Enabled(
  env: { VITE_DECISIONS_V2_ENABLED?: string } = import.meta.env
): boolean {
  return env.VITE_DECISIONS_V2_ENABLED === 'true';
}
